import { render, staticRenderFns } from "./AcordionA.vue?vue&type=template&id=384632c0&scoped=true&lang=pug&"
import script from "./AcordionA.vue?vue&type=script&lang=js&"
export * from "./AcordionA.vue?vue&type=script&lang=js&"
import style0 from "./AcordionA.vue?vue&type=style&index=0&id=384632c0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384632c0",
  null
  
)

export default component.exports